body.tox-dialog__disable-scroll {
  overflow: hidden;
}
.tox-fullscreen {
  border: 0;
  height: 100%;
  margin: 0;
  overflow: hidden;
  overscroll-behavior: none;
  padding: 0;
  touch-action: pinch-zoom;
  width: 100%;
}
.tox.tox-hugerte.tox-fullscreen .tox-statusbar__resize-handle {
  display: none;
}
.tox.tox-hugerte.tox-fullscreen,
.tox-shadowhost.tox-fullscreen {
  left: 0;
  position: fixed;
  top: 0;
  z-index: 1200;
}
.tox.tox-hugerte.tox-fullscreen {
  background-color: transparent;
}
.tox-fullscreen .tox.tox-hugerte-aux,
.tox-fullscreen ~ .tox.tox-hugerte-aux {
  z-index: 1201;
}
